export default {
  title: 'Añadir tarjeta',
  buttons: {
    save: 'Guardar',
  },
  feedback: {
    success: 'Tarjeta guardada correctamente',
  },
};
